<div class="category-home-description">
    <div id="searchResults" class="gcse-searchresults-only"></div>
</div>